import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var ThumbsUpFilledSvg = function ThumbsUpFilledSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m6.83 6.172-1.112 4.172H2V22h15.429l2.28-6.734L22 8.502c.01-.024-.88-.03-4.401-.03h-4.413V7.098c0-1.426-.01-1.615-.105-2.002a4.3 4.3 0 0 0-.67-1.458 3.9 3.9 0 0 0-2.124-1.494c-.402-.11-.512-.12-1.445-.132L7.942 2zM3.432 16.16v4.348h2.114v-8.695H3.432z",
      clipRule: "evenodd"
    })
  });
};
export var ThumbsUpFilled = function ThumbsUpFilled(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: ThumbsUpFilledSvg
  }));
};